var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Title } from "../../designSystem";
import colors from "../../designSystem/colors";
var Container = styled.div.attrs({
    className: "d-flex align-items-center justify-content-center",
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  height: 100vh;\n"], ["\n  background-color: ", ";\n  height: 100vh;\n"])), colors.background.one);
var TextPreview = function (_a) {
    var children = _a.children, titleStyle = _a.titleStyle;
    return (_jsx(Container, { children: _jsx(Title, __assign({ style: titleStyle, fontSize: 24, color: colors.primaryText }, { children: children }), void 0) }, void 0));
};
export default TextPreview;
var templateObject_1;
//# sourceMappingURL=TextPreview.js.map